import { Button, Stack, SxProps } from '@mui/material'
import { ArrowLeft } from 'react-feather'
import { Trans } from 'react-i18next'
import React from 'react'
import { backButtonStyles, continueButtonStyles } from './OnboardingNavigation.styles'
import { useTheme } from '@mui/material/styles'
import CircularProgress from '@mui/material/CircularProgress'

type OnboardingNavigationProps = {
	i18nForwardLabel: string
	backClick?: (e: React.MouseEvent<HTMLButtonElement>) => void
	forwardClick?: (e: React.MouseEvent<HTMLButtonElement>) => void
	disableForward?: boolean
	loading?: boolean
	sx?: SxProps
}

export default function OnboardingNavigation({
	i18nForwardLabel,
	backClick,
	forwardClick,
	disableForward = false,
	loading = false,
	sx,
}: OnboardingNavigationProps) {
	const { palette } = useTheme()
	return (
		<Stack direction="row" gap="16px" sx={sx}>
			{backClick && (
				<Button variant="outlined" sx={backButtonStyles(palette)} onClick={backClick}>
					<ArrowLeft width="20px" height="20px" />
					<Trans i18nKey="onboarding.layout.back_button_label" />
				</Button>
			)}
			{forwardClick && (
				<Button
					variant="contained"
					sx={continueButtonStyles(palette)}
					onClick={forwardClick}
					disabled={disableForward || loading}
				>
					{loading ? (
						<CircularProgress style={{ height: '25px', width: '25px' }} />
					) : (
						<Trans i18nKey={i18nForwardLabel} />
					)}
				</Button>
			)}
		</Stack>
	)
}
